import { jsx as l } from "@emotion/react/jsx-runtime";
import { SingleSelect as r } from "@partoohub/ui";
import { useBusinessModalContext as c } from "../../../../../BusinessModalContext.js";
import { useCitySection as m } from "../../../../../hooks/options/useCitySection.js";
import { setSearchCity as p } from "../../../../../reducer/businessModal.actions.js";
const g = () => {
  const {
    dispatch: s,
    translations: i,
    preFilters: o
  } = c(), t = m(), n = t.flatMap((e) => e.options).find((e) => o?.searchCity === e.value), a = (e) => {
    s(p(e));
  };
  return t.length === 0 ? null : /* @__PURE__ */ l(r, { dataTrackId: "business_modal__multiselect__cities", sections: t, selectedValue: n, onChange: a, label: i.cities, maxHeight: 300 });
};
export {
  g as SelectCities
};
